import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { PreventInspectService } from './services/prevent-inspect/prevent-inspect.service';
import AOS from 'aos';
import { isPlatformBrowser } from '@angular/common';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppModeService } from './services/app-mode.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  currentUrl: string = '';
  constructor(
    private readonly preventInspectService: PreventInspectService,
    @Inject(PLATFORM_ID) private readonly platformId: Object,
    private readonly router: Router,
    private readonly translate: TranslateService,
    public readonly appModeService: AppModeService,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        const lang = localStorage.getItem('lang') || 'en';
        const url = event.url;

        const [pathPart, queryPart] = url.split('?');
        const segments = pathPart.split('/').filter(Boolean);

        if (!segments.length || segments[0] !== lang) {
          if (segments.length && segments[0].length === 2) {
            segments[0] = lang;
          } else {
            segments.unshift(lang);
          }

          const newUrl =
            '/' + segments.join('/') + (queryPart ? `?${queryPart}` : '');
          this.router.navigateByUrl(newUrl, { replaceUrl: true });
        }
      }
    });

    translate.onLangChange.subscribe((event) => {
      const lang = event.lang;
      document.documentElement.lang = lang;
      document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    });
    this.router.events.subscribe((event) => {
      if (
        isPlatformBrowser(this.platformId) &&
        event instanceof NavigationEnd
      ) {
        this.currentUrl = event.urlAfterRedirects;
        document.body.classList.toggle(
          'home-page-body',
          event.urlAfterRedirects === '/',
        );
      }
    });
  }

  shouldHideAppChrome(): boolean {
    if (!this.appModeService.isApp()) {
      return false;
    }

    const url = this.currentUrl || this.router.url || '';

    return /\/[a-z]{2}\/(profile\/myorders|profile\/order-details\/[^/?#]+|order-success(\/[^/?#]+)?|profile|wishlist|login|register|forgot-password|verify-otp|create-password|choose-language|products\/[^/?#]+)(\?.*)?$/.test(
      url,
    );
  }
  shouldHideBottomNav(): boolean {
    if (!this.appModeService.isApp()) {
      return false;
    }

    const url = this.currentUrl || this.router.url || '';

    return /\/[a-z]{2}\/(login|register|profile\/myorders|profile\/order-details\/[^/?#]+|order-success(\/[^/?#]+)?|forgot-password|verify-otp|create-password|choose-language)(\/[^/?#]+)?(\?.*)?$/.test(
      url,
    );
  }
  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      AOS.init();
    }
  }
}
